import { render, staticRenderFns } from "./AutocompleteTrabajador.vue?vue&type=template&id=2b42c7e2&"
import script from "./AutocompleteTrabajador.vue?vue&type=script&lang=js&"
export * from "./AutocompleteTrabajador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports